module.exports = "/_next/static/images/content-badge-tier-1-696b56a6060b23eeb180469c5d7050fd.png";